
import React, { Component } from "react";
import styled, { keyframes } from "styled-components";
import { connect } from "react-redux";
import {
  TYPE_MODAL_BALANCE_CERO,
  TYPE_MODAL_BALANCE_ERROR
} from "../../constants";
import { executeTaggeo } from "../../store/actions";
import { 
  getOriginParamsSelector, 
  getServiceId, 
  getTagServiceId, 
  getServiceName 
} from "../../store/selectors/paymentsSelectors";
import { decodeParamsFromUrl } from "../organisms/BodyPaymentFormClaroSocio/utils.js/decodeParamsFromUrl";
import { getServicesTelcel, taggeoCleanString} from "../organisms/utils";

/* Animaciones */
const fadeIn = keyframes`
  from { opacity: 0; }
  to { opacity: 1; }
`;

const slideUp = keyframes`
  from { transform: translateY(100%); }
  to { transform: translateY(0); }
`;

/* Estilos */
const Overlay = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(0,0,0,0.65);
  animation: ${fadeIn} 0.3s ease;
  display: flex;
  justify-content: center;
  align-items: flex-end;
  z-index: 999;
`;

const ModalContainer = styled.div`
  width: 100%;
  height: 70vh;
  background: #FFFFFF;
  border-radius: 16px 16px 0 0;
  animation: ${slideUp} 0.35s ease;
  padding: 24px 16px;
  box-sizing: border-box;
  position: relative;
`;

const CloseIcon = styled.img`
  width: 20px;
  height: 20px;
  display: block;
  margin-top: -5px;
`;

const CloseButton = styled.div`
  position: initial;
  justify-content: flex-end;
  top: 24px;
  right: 16px;
  display: flex;
  align-items: center;
  gap: 4px;
  font-family: AMX-Bold;
  font-size: 16px;
  color: #0071D1;
  cursor: pointer;
  user-select: none;
  font-style: normal;
  font-weight: 700;
  line-height: 21px;
`;

const ImgBanner = styled.img`
  width: 100%;
  height: 150px;
  display: block;
  margin: 16px 0 24px 0;
`;

const Title = styled.p`
  font-family: AMX-Bold;
  font-size: 18px;
  color: #222;
  margin: 24px 0 8px 0;
`;

const Subtitle = styled.p`
  font-family: AMX-Regular;
  font-size: 16px;
  color: #222;
  margin: 0 0 80px 0;
`;

const Button = styled.p`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 4px;
  gap: 10px;
  margin: 0 auto;
  width: 326px;
  min-width: 120px;
  max-width: 358px;
  height: 40px;
  min-height: 40px;
  max-height: 40px;
  background: #7B1FA2;
  border-radius: 100px;
  cursor: pointer;
`;

const TextButton = styled.p`
  font-family: AMX-Bold;
  font-size: 16px;
  color: #FFF;
  margin: 0;
`;

export const variant = {
  [TYPE_MODAL_BALANCE_CERO]: {
    title: "Tu servicio está al corriente",
    subtitle: "Aun así, puedes adelantar tu pago con el monto que prefieras.",
    imageSrc: "/images/modal_telcel_saldo_al_corriente.png",
    modalName: "tu servicio esta al corriente"
  },
  [TYPE_MODAL_BALANCE_ERROR]: {
    title: "No fue posible consultar el saldo de &lt;br/&gt;tu servicio",
    subtitle: "Pero puedes pagar el monto que prefieras.",
    imageSrc: "/images/modal_telcel_saldo_error.png",
    modalName: "no fue posible consultar el saldo de tu servicio"
  },
};
const paramsTaggeoTelcelStatics = {
  seccion : "servicios",
  pantalla: "formulario de pago"

}
/* Componente clase */
class ModalCheckBalanceContainer extends Component {

  constructor(props) {
    super(props);      
    this.state = {}   
  }
  
  componentDidMount() {
    const { 
      executeTaggeo, originAnalytic, serviceId, 
      tagServiceId, typeModal, checkBalanceResponse
    } = this.props;
    if (typeof executeTaggeo === "function") {
      executeTaggeo({
        ...paramsTaggeoTelcelStatics,
        subseccion: getServicesTelcel(serviceId),
        origen: decodeParamsFromUrl(originAnalytic, "analyticOrigin"),
        nombreServicio : tagServiceId,
        tipoElemento: "modal",
        nombreElemento:  variant[typeModal].modalName,
        trackState: true,
        ...(typeModal === TYPE_MODAL_BALANCE_ERROR && {
          error_mensajeBack: taggeoCleanString(checkBalanceResponse.responseMessage),
          error_mensaje: variant[typeModal].modalName,
          error_codigoEstatus: checkBalanceResponse.codeTelcel,
          isError:true
        })
      }, true);
    }
  }

  // Normaliza el título: si viene con &lt;br/&gt; lo convertimos a <br />
  getTitleMarkup = (rawTitle) => {
    if (!rawTitle) return { __html: "" };
    const normalized = rawTitle
      .replace(/&lt;br\/&gt;|&lt;br\s*\/&gt;|&lt;br&gt;/gi, "<br />")
      .replace(/&amp;/g, "&"); // por si llega escapado
    return { __html: normalized };
  };

  // Normaliza el título: si viene con &lt;br/&gt; lo convertimos a <br />
  handleOnClose = (clickButtonUnderstood) => {
    const { onClose } = this.props;
    const { executeTaggeo, originAnalytic, serviceId, tagServiceId, typeModal, serviceName } = this.props;
    if(clickButtonUnderstood ){
      if(typeModal == TYPE_MODAL_BALANCE_CERO){
        document.getElementById("pagoDeServicios_amount_" + serviceName).focus();
      }
      if (typeof executeTaggeo === "function") {
        executeTaggeo({
          ...paramsTaggeoTelcelStatics,
          subseccion: getServicesTelcel(serviceId),
          origen: decodeParamsFromUrl(originAnalytic, "analyticOrigin"),
          nombreServicio : tagServiceId,
          tipoElemento: "boton",
          nombreElemento:  "entendido",
          trackAction: true,
          ...(typeModal === TYPE_MODAL_BALANCE_ERROR && {
            isError:true
          })
        }, true);
      }
    }
    onClose();
  };

  render() {
    const { open, typeModal } = this.props;
    if (!open) return null;

    const cfg = variant[typeModal] || variant[TYPE_MODAL_BALANCE_ERROR];

    return (
      <Overlay>
        <ModalContainer onClick={(e) => e.stopPropagation()}>
          <CloseButton onClick={ () => this.handleOnClose(false)}>
            <span>Cerrar</span>
            <CloseIcon src={"/images/close_modal.svg"} alt="Cerrar" />
          </CloseButton>
          <ImgBanner src={cfg.imageSrc} alt="" />
          <Title dangerouslySetInnerHTML={this.getTitleMarkup(cfg.title)} />
          <Subtitle>{cfg.subtitle}</Subtitle>
          <Button onClick={() => this.handleOnClose(true)} role="button" aria-label="Entendido">
            <TextButton>Entendido</TextButton>
          </Button>
        </ModalContainer>
      </Overlay>
    );
  }
}


const mapStateToProps = (state) => ({
  originAnalytic : getOriginParamsSelector(state),
  serviceId : getServiceId(state),
  tagServiceId : getTagServiceId(state.payments),
  checkBalanceResponse: state.payments.amountTelcelPospago,
  serviceName: getServiceName(state)
});


const mapDispatch = { executeTaggeo };

export default connect(mapStateToProps, mapDispatch)(ModalCheckBalanceContainer);
